export default [
  {
    path: '/social-post',
    component: () => import('@/views/social/post/Index.vue'),
    name: 'social.post',
    meta: {
      // appName: 'SocialPost',
      title: '贴子',
      auth: 0,
      visibleShare: false,
      backgroundClass: 'bg-white',
    },
    hidden: true,
  },
  {
    path: '/social-post-detail-:id',
    component: () => import('@/views/social/post/Detail.vue'),
    name: 'social.post.detail',
    meta: {
      appName: 'SocialPostDetail',
      title: '贴子详情',
      auth: 0,
      visibleShare: false,
      backgroundClass: 'bg-white',
    },
    hidden: true,
  },
];
